import { Skeleton } from '@qodo/design-system';

/**
 * Suspense fallback for the lazy-loaded Team Profiles routes (catalog +
 * detail). Shown only during the JS chunk download — once the chunk resolves,
 * the page's own data-phase skeleton (`PersonaDetailSkeleton`) or table
 * loading state takes over.
 *
 * PER-138 #6: the shared route fallback was a bare centered `<Loader>` ("•••")
 * floating in empty space, which read as a broken/blank page during a cold
 * chunk load. This renders a neutral header + content skeleton instead so the
 * load looks intentional and the layout doesn't jump when content arrives.
 * Kept deliberately generic (it has no persona data yet) and dependency-light
 * so it stays in the main bundle — a fallback can't import from the chunk it's
 * waiting on.
 */
export const TeamProfilesRouteFallback = () => (
  <div
    role="status"
    aria-busy="true"
    aria-label="Loading Team Profiles…"
    data-testid="team-profiles-route-fallback"
    className="flex size-full flex-col gap-6 p-6"
  >
    <div className="flex items-center justify-between gap-4">
      <Skeleton className="h-8 w-64 max-w-full" />
      <Skeleton className="h-9 w-28 shrink-0" />
    </div>
    <div className="flex flex-col gap-3">
      <Skeleton className="h-5 w-48" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-11/12" />
      <Skeleton className="h-4 w-10/12" />
      <Skeleton className="h-4 w-9/12" />
    </div>
  </div>
);
